import React from "react";
import { withTranslation } from "react-i18next";
function Footer(props) {
  return <footer className="footerbg">© 2021 Clockli</footer>;
}
export default withTranslation()(Footer);
